<template>
  <div>
    <v-toolbar v-if="page === 'Schools Folders'" dense class="elevation-1">
      <v-icon color="purple" class="text-h4">mdi-human-male-board</v-icon>
      <v-toolbar-title
        :style="
          $vuetify.breakpoint.smAndUp
            ? 'letter-spacing: 0.5rem'
            : 'letter-spacing: 0.2rem'
        "
        class="ml-3 font-weight-bold"
        >Schools Folders
      </v-toolbar-title>
    </v-toolbar>
    <v-toolbar v-if="page === 'Schools Files'" class="darkblue">
      <v-btn dark rounded color="darkpink" @click="backFolder()">
        <v-icon left>mdi-arrow-left</v-icon> Voltar</v-btn
      >
    </v-toolbar>
    <FileSchoolsFolders
      v-if="page === 'Schools Folders'"
      @enterFiles="updatePage"
    ></FileSchoolsFolders>
    <FileSchoolsFiles v-if="page === 'Schools Files'" :idSchools="idSchools"></FileSchoolsFiles>
  </div>
</template>

<script>
import FileSchoolsFolders from "./FileSchoolsFolders.vue";
import FileSchoolsFiles from "./FileSchoolsFiles.vue";
export default {
  components: {
    FileSchoolsFolders,
    FileSchoolsFiles,
  },
  data() {
    return {
      page: "Schools Folders",
      idSchools: null,
    };
  },
  methods: {
    backFolder() {
      this.page = "Schools Folders";
    },
    updatePage(variable) {
      this.page = variable.path;
      this.idSchools = variable.idSchools;
    },
    addNewFolder() {
      let i = this.formFolder.files.length;

      this.testFolders.push({
        title: this.formFolder.name,
        subtitle: i + " arquivos",
      });
      this.newFolderDialog = false;
    },
  },
};
</script>

<style lang="css" scoped></style>
